import { render, staticRenderFns } from "./brandPartyAdd.vue?vue&type=template&id=3b8102e9"
import script from "./brandPartyAdd.vue?vue&type=script&lang=js"
export * from "./brandPartyAdd.vue?vue&type=script&lang=js"
import style0 from "./brandPartyAdd.vue?vue&type=style&index=0&id=3b8102e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports